import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";

const renderIcon = (checkmark: boolean) => {
    return checkmark
        ? html`<ux-icon name="checkmark" weight="bold"></ux-icon>`
        : html`<ux-icon name="minus"></ux-icon>`;
};

const renderTable = (index: number) => html`
    <div class="ux-iws-comparison-matrix__table">
        <div class="ux-iws-comparison-matrix__table-legend">
            <div>Laser</div>
            <div>Bearbeitungsoptiken</div>
        </div>
        <ux-table mobile-accordion="false" full-width>
            <table tabindex="0">
                <thead>
                    <tr>
                        <th></th>
                        <th scope="col">PFO 2D</th>
                        <th scope="col">PFO 3D</th>
                        <th scope="col">BEO D35</th>
                        <th scope="col">BEO D70</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">TruFlow</th>
                        <td>${renderIcon(index % 3 === 0)}</td>
                        <td>${renderIcon(index % 3 === 1)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 0)}</td>
                    </tr>
                    <tr>
                        <th scope="row">TruDisk</th>
                        <td>${renderIcon(index % 3 === 1)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 0)}</td>
                        <td>${renderIcon(index % 3 === 1)}</td>
                    </tr>
                    <tr>
                        <th scope="row">TruPulse</th>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 0)}</td>
                        <td>${renderIcon(index % 3 === 1)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                    </tr>
                    <tr>
                        <th scope="row">TruFiber</th>
                        <td>${renderIcon(index % 3 === 0)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 1)}</td>
                    </tr>
                    <tr>
                        <th scope="row">
                            TruMicro example with long label text
                        </th>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 1)}</td>
                        <td>${renderIcon(index % 3 === 0)}</td>
                    </tr>
                    <tr>
                        <th scope="row">TruDiode</th>
                        <td>${renderIcon(index % 3 === 1)}</td>
                        <td>${renderIcon(index % 3 === 0)}</td>
                        <td>${renderIcon(index % 3 === 2)}</td>
                        <td>${renderIcon(index % 3 === 0)}</td>
                    </tr>
                </tbody>
            </table>
        </ux-table>
    </div>
`;

export const Template = ({ firstColumnWidth }) => html`
    <ux-iws-comparison-matrix first-column-width=${ifDefined(firstColumnWidth)}>
        <div class="ux-u-my-xxxs" slot="header">
            <ux-select label="Select" aria-controls="comparisonTables">
                <option>Table 1</option>
                <option>Table 2</option>
                <option>Table 3</option>
            </ux-select>
        </div>
        <div id="comparisonTables">
            ${renderTable(0)} ${renderTable(1)} ${renderTable(2)}
        </div>
    </ux-iws-comparison-matrix>
`;
